<div
  #cm
  class="bfx-context-menu"
  [ngStyle]="{'display': isDisplayed? 'block':'none','visibility': isVisible? 'visible':'hidden'}"
  [style.width.px]="minMenuWidth"
  [style.max-height.px]="containerHeight"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
>
  <ul>
    <!--  TODO: change css classes -->
    <li
      *ngFor="let menuItem of menuItems"
      class="bfx-context-menu-item-enabled"
      (pointerup)="selectedMenuItem(menuItem, $event)"
    >
      <span>{{menuItem.title}}</span>
    </li>
  </ul>
</div>
